// extracted by mini-css-extract-plugin
export default {"tabButton":"TeamTabs_tabButton__so2pa","active":"TeamTabs_active__nDJTe","contentWrapper":"TeamTabs_contentWrapper__pmCj5","fadeIn":"TeamTabs_fadeIn__J2SQP"};